function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 7.80563C3.10556 7.80563 4 8.7145 4 9.83789C4 10.9613 3.10556 11.8701 2 11.8701C0.894444 11.8701 0 10.9613 0 9.83789C0 8.7145 0.894444 7.80563 2 7.80563ZM0 2.87015C0 3.99354 0.894444 4.90241 2 4.90241C3.10556 4.90241 4 3.99354 4 2.87015C4 1.74676 3.10556 0.837891 2 0.837891C0.894444 0.837891 0 1.74676 0 2.87015ZM0 16.8056C0 17.929 0.894444 18.8379 2 18.8379C3.10556 18.8379 4 17.929 4 16.8056C4 15.6822 3.10556 14.7734 2 14.7734C0.894444 14.7734 0 15.6822 0 16.8056Z",
  fill: "#E5EBED"
});

var SvgBtnMenu3Dot = function SvgBtnMenu3Dot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 19,
    viewBox: "0 0 4 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBtnMenu3Dot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/btn-menu-3-dot.4cf47b54.svg";
export { ForwardRef as ReactComponent };